module.exports = __webpack_public_path__ + "img/weixin.572984e9.png";